
import React from 'react';
import { useQuery } from "@tanstack/react-query";
import { useUrlFriendlyToParameters } from 'helpers/urlFriendly';
import Loader from 'components/general/Loader'
import NotAvailable from "components/common/NotAvailable";
import { getTeamBio } from 'data/Querys';
import BioAnchors from "components/common/participants/BioAnchors"
import BioSchedule from 'components/common/participants/BioSchedule';
import TeamMembers from "components/common/participants/TeamMembers"
import BioMedals from "components/common/participants/BioMedals"
import BioData from "components/common/participants/BioData"
import TeamOfficials from 'components/common/participants/TeamOfficials';
import TeamRecords from 'components/common/participants/TeamRecords';
import { usePreparePayLoad } from 'components/common/ocs-custom-events/helpers';
import FireOnContentLoadOCS from 'components/general/FireOnContentLoadOCS';
import { useScrollToTop } from 'helpers/utils';

export default function Team() {
    const params = useUrlFriendlyToParameters()
    let paramsURL = { ...params }
    const payloadParams = usePreparePayLoad()
    useScrollToTop();

    const { data, isError, isLoading } = useQuery(
        {
            queryKey: ['team', paramsURL['mirs_competition'], paramsURL['mirs_language'], paramsURL['mirs_code']],
            queryFn: getTeamBio,
            enabled: true,
            refetchInterval: 0,
            staleTime: Infinity,
            refetchIntervalInBackground: true,
            retry: false,
            suspense: false
        });


    if (isError) {
        return <NotAvailable label="LabelNoDataAvailable" />;
    }
    if (isLoading) {
        return <Loader />;
    }
    if (!data?.team) {
        return <NotAvailable label="LabelNoDataAvailable" />
    }

    return (
        <>
            <FireOnContentLoadOCS params={params} data={data} payloadParams={payloadParams} type={'team'} />
            <div className='mirs-page-container'>
                <div className="wrsBiosDetail__panel">

                    <div className="bios-personalinfo">

                        <BioAnchors data={data} />
                    </div>


                    {data?.team?.registeredEvents &&
                        <BioMedals data={data} />
                    }
                    {data?.team?.athletes &&
                        <TeamMembers data={data} />
                    }
                    {data?.team?.teamCoaches &&
                        <TeamOfficials data={data} />
                    }
                    {data?.team?.records &&
                        <TeamRecords data={data} />
                    }
                    <BioSchedule data={data} />
                    {
                        <BioData data={data} />
                    }
                </div>
            </div>
        </>
    )
};
